'use client';

import React from 'react';

import { Plus, Download } from 'lucide-react';

export default function WorkOrderHeader() {
  return (
    <div className="bg-card border-b border-border px-6 lg:px-8 xl:px-10 2xl:px-12 py-4">
      <div className="max-w-screen-2xl mx-auto flex items-center justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-2xl font-700 text-foreground">Ordens de Serviço</h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            Gestão completa do ciclo de vida das OS · Campus Universitário
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button className="inline-flex items-center gap-1.5 bg-card border border-border text-foreground text-sm font-600 px-3 py-2 rounded-lg hover:bg-secondary active:scale-95 transition-all duration-150">
            <Download size={15} />
            Exportar
          </button>
          <button className="inline-flex items-center gap-1.5 bg-primary text-primary-foreground text-sm font-600 px-3 py-2 rounded-lg hover:bg-primary/90 active:scale-95 transition-all duration-150 shadow-card">
            <Plus size={15} />
            Nova OS
          </button>
        </div>
      </div>
    </div>
  );
}